import React from 'react';
import IconButton from '../../../../components/IconButton';
import Badge from '../../../../components/Badge';
import { paths } from '../../../../routes';
import Icon from '../../../../components/Icon';

const Messages = ({ isUnreadMessages }) => {
    return (
        <IconButton
            to={paths.chat}
            type="navlink"
        >
            <Badge
                invisible={!isUnreadMessages}
            >
                <Icon
                    name="chat"
                    height="16"
                    width="14"
                />
            </Badge>
        </IconButton>
    );
};

export default Messages;
